import { CardComponentProps } from "@~/types/types";
import styles from "./GiftMessagesIndicator.module.scss";
import { IconButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import { FeedbackOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/FeedbackOutlined";
import { VIEW_GIFT_MESSAGES } from "@~/utils/events";
import { useVariant } from "@~/contexts/VariantContext/VariantContext.tsx";

export function GiftMessagesIndicator({
  product,
}: Pick<CardComponentProps, "product">) {
  const { giftMessageCount = 0 } = product;
  const { variant } = useVariant();

  if (giftMessageCount === 0) {
    return null;
  }

  const handleClick = () => {
    window.dispatchEvent(
      new CustomEvent(VIEW_GIFT_MESSAGES, {
        detail: {
          pimProductId: product.aliases.pimProductId,
          skuId: variant?.aliases?.skuId,
        },
      }),
    );
  };

  return (
    <div
      data-component="pcl-GiftMessagesIndicator"
      className={styles.giftMessagesButton}
    >
      <>
        <IconButton
          onClick={handleClick}
          data-testid="view-messages-button"
          aria-label="View messages"
          size="small"
          icon={FeedbackOutlined}
        />
        <div className={styles.countIndicator}>
          <div className={styles.countText}>{giftMessageCount}</div>
        </div>
      </>
    </div>
  );
}
